export default "__VITE_ASSET__CW$pDoi2__"